import React, {useContext, useState} from 'react';
import {
    StyledSubhero,
} from './styled'
import {AppContext} from '../../contexts'
import { colors } from "../../branding";
import { scrollToElement } from '../../utilities/index'
import { Link } from "react-router-dom";


const Subhero = (props) => {
    const {updateAppContext} = useContext(AppContext);
    const {children} = props

    const renderContactFormButtons = () => {
        return (
            <>
                <Link className="button" to={`/mailwall-Pricing`} title='PRICING' onClick={scrollToElement}>PRICING</Link>
                <Link className="button" to={`/mailwall-Bookademo`} title='BOOK A DEMO' onClick={scrollToElement}>BOOK A DEMO</Link>
                <Link className="button" to={`/mailwall-Startfreetrial`} title='CALL ME' onClick={scrollToElement}>CALL ME</Link>
            </>
        )
    }

    return (
        <StyledSubhero className={"Hero"}>
            <div className="Hero-content-section">
            <Link className="Backtohome" to={`/mailwall-email-filtering`} title='PRICING' onClick={scrollToElement}>&lt;&lt; Back to main page</Link>
                <div className="Hero-buttons">
                    {renderContactFormButtons()}
                </div>
                <div className="Hero-text">
                    {children}
                </div>
            </div>
        </StyledSubhero>
    )
}

export default Subhero;
